<template>
    <div>
      <data-table
        title="White listed users"
        ref="table"
        :url="url"
        :headers="headers"
        searchable
        :csv="false"
        :archive="false"
        @click:row="showDetails"
        @rowClicked="showDetails"
      >

      <template #action.icons>
        <div class="d-flex mr-3 justify-center items-center">
          <v-select
            label="County"
            dense
            v-model="country"
            solo
            filled
            clearable
            :items="highriskcountries"
          ></v-select>
        </div>
      </template>
        <!-- new date formatter -->
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment }}
        </template>
        <span slot="item.type" slot-scope="{ item }" v-text="getUserType(item)" />

        <template slot="item.status" slot-scope="{ item }">
          <v-icon color="success" v-if="item.is_active">mdi-progress-check</v-icon>
          <v-icon color="warning" v-else>mdi-information-outline</v-icon>
        </template>
      </data-table>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import { getUserType } from "./utils";
  
  export default {
    data() {
      return {
        country: "",
        highriskcountries:[],
        status:"",
        url: "api/v1/users/whitelisted",
        headers: this.pairTableLabelWithValue({
          "White listed at": "whitelisted_at",
          "Created at": "created_at",
          "First Name": "first_name",
          "Last Name": "last_name",
          Email: "email",
          Country: "country",
          "Phone Number": "full_phone_number",
          Type: "type",
          "Compliance Scoring": "compliance_score",
          "Activation Scoring": "activation_scoring",
          Status: "status",
        }),
        
      };
    },

    async mounted() {
      await this.fetchHighRiskCountry();
    },

    watch: {
      url() {
        this.$nextTick(() => {
          this.$refs.table.fetchData();
        });
      },
      country(val) {
        let data = { name: "country", value: "" };
        if (val) {
          data = { name: "country", value: val };
        }
        const params = this.$refs.table.addParams(this.url, [data]);
        this.url = `api/v1/users/whitelisted?${params}`;
      }
    },
  
    filters: {
      moment: function (date) {
        return moment(date).format("DD/MM/YYYY hh:mm:ss");
      },
    },
  
    methods: {
      async syncUserBalance() {
        let lastSyncDate = localStorage.getItem("last_date_of_user_sync");
        if (lastSyncDate != null && moment(lastSyncDate).isAfter(moment().subtract(1, "hours"))) {
          Notify.error("Too Many Sync Requests.Try again in an hour");
        } else {
          await Notify.confirm(`Please note that this action takes about an hour to complete`).then(
            () => {
              this.$http
                .get(`/api/v1/users/sync-balances`)
                .then(async () => {
                  localStorage.setItem("last_date_of_user_sync", await moment(new Date()).format());
                  Notify.success("User balance synchronisation has been started");
                  window.location.reload();
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error) => {
                  Notify.error(error.message);
                });
            },
          );
        }
      },
      showDetails({ id }) {
        this.$router.push({ name: "users.show", params: { id } });
      },
      getUserType,
      async fetchHighRiskCountry(){
        try {
          const response = await this.$http.get('api/v1/countries/highrisk');
          this.highriskcountries = response.map(country => ({
            text: country.name,
            value: country.id
          }));
        } catch (error) {
          Notify.error(error.message);
        }
      }
    },
  };
  </script>
  